// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__355u4","content":"styles_content__eHqfV","row":"styles_row__27Xyn","footer":"styles_footer__35l1F","phraseLength":"styles_phraseLength__3y5gD"};